import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import './style.css';
const messages = defineMessages({
  SH_EnableOrDisable: {
    id: 'SH_EnableOrDisable',
    defaultMessage: '啟/停用',
  },
});
class Switch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enableIcon: <i className="fa fa-toggle-on py__toggle"></i>,
      disableIcon: <i className="fa fa-toggle-off py__toggle"></i>,
    };
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleToggle() {
    const { onToggle, value } = this.props;
    if (onToggle) {
      onToggle(!value);
    }
  }

  renderToggleIcon(value) {
    const { enableIcon, disableIcon } = this.state;
    switch (value) {
      case false:
        return disableIcon;
      case true:
        return enableIcon;
      default:
        return disableIcon;
    }
  }

  render() {
    const { disabled, intl, value } = this.props;

    return (
      <i
        style={{ verticalAlign: 'middle', cursor: 'pointer' }}
        title={intl.formatMessage(messages.SH_EnableOrDisable)}
        onClick={
          disabled ?
          () => {} :
          this.handleToggle
        }
      >
        {this.renderToggleIcon(value)}
      </i>
    );
  }
}

Switch.propTypes = {
  data: PropTypes.node,
  onToggle: PropTypes.func,
  disabled: PropTypes.bool,
  value: PropTypes.bool,
  intl: intlShape.isRequired,
};
export default injectIntl(Switch);



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/components/switch/index.js
 **/